module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av599-7b468ef5e46cd61aa91b23bc9725e183.jpg";